import { render, staticRenderFns } from "./register-view.vue?vue&type=template&id=7f5be339"
import script from "./register-view.vue?vue&type=script&lang=js"
export * from "./register-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports